import React from 'react';
import { Badge, BadgePriority } from '@wix/wix-ui-tpa/cssVars';
import { useTranslation } from '@wix/yoshi-flow-editor';

import type { FeaturedBadgeAlignmentName } from '../HighlightedItem/constants';
import {
  getFeaturedTypeLabel,
  isSupportedFeaturedType,
  type FeaturedType,
} from '../../utils/featuredType';

import { classes, st } from './FeaturedBadge.st.css';

interface FeaturedBadgeProps {
  featuredType?: FeaturedType;
  onImage?: boolean;
  alignment?: FeaturedBadgeAlignmentName;
  dataHook?: string;
}

export const FeaturedBadge = ({
  featuredType,
  onImage = false,
  alignment = 'start',
  dataHook,
}: FeaturedBadgeProps) => {
  const { t } = useTranslation();

  if (!isSupportedFeaturedType(featuredType)) {
    return null;
  }

  return (
    <Badge
      className={st(classes.featuredBadge, { onImage, alignment })}
      data-hook={dataHook}
      priority={BadgePriority.light}
    >
      {getFeaturedTypeLabel(featuredType, t)}
    </Badge>
  );
};
